import { api } from "core";

export async function getApiKey() {
    return api.get("api-key");
}

export async function createApiKey() {
    return api.post("api-key", {});
}

export async function deleteApiKey() {
    return api.delete("api-key");
}